
/**
 * @license
 * Copyright Lamb Team. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Reveal fieldset component.
 *
 * @example
 *
 * ```
 * <gw1-input-icon>
 *     <i class="fa fa-search"></i>
 *     <input type="text" placeholder="Este es mi placeholder" class="form-control form-control-sm" id="customer">
 * </gw1-input-icon>
 * ```
 */
import { NgModule } from '@angular/core';

import { LambInputIconComponent } from './input-icon.component';

@NgModule({
    imports: [],
    exports: [LambInputIconComponent],
    declarations: [LambInputIconComponent],
    providers: [],
})
export class gw3InputIconModule { }
